// extracted by css-extract-rspack-plugin
export default {"menu":"EMXeb5EsjgZTxamZ","menuItem":"dPD5d5v60Jo3mL_z","section":"QiIAXDqB3qM_tuVV"};